import React, { useEffect, useState } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import styles from './Comparison.module.scss';
import { RootState } from 'MyTypes';
import { comparisonSelectedSelector } from '../../comparisonSelectors';
import * as appConfigActions from '../../../AppConfig/appConfigActions';
import * as comparisonActions from '../../comparisonActions';
import { AppView } from '../../../Common/types/AppConfigTypes';
import { HydratedCurriculumType } from '../../../Common/types/AppConfigTypes';

interface ComparisonProps {
    curriculumType: HydratedCurriculumType;
}

const mapStateToProps = (state: RootState) => ({
    selectedList: comparisonSelectedSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
        {
            setAppView: appConfigActions.setAppView,
            removeSelectedItem: comparisonActions.removeComparisonSelectedItem,
            getSelectedLabels: comparisonActions.getSelectedLabels,
        },
        dispatch,
    );

type Props = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps> &
    ComparisonProps;

const Comparison: React.FC<Props> = ({
    curriculumType,
    removeSelectedItem,
    getSelectedLabels,
    selectedList,
    setAppView,
}) => {
    const withoutLabels =
        selectedList &&
        selectedList.filter(
            selected =>
                selected &&
                (selected.label === '' || selected.label === undefined),
        );
    const hasSelectedWithoutLabels = !!(
        withoutLabels && withoutLabels.length > 0
    );
    const [shouldFetchLabels, setShouldFetchLabels] = useState<boolean>(
        hasSelectedWithoutLabels,
    );

    useEffect(() => {
        if (curriculumType && shouldFetchLabels) {
            getSelectedLabels();
            setShouldFetchLabels(false);
        }
    }, [curriculumType, shouldFetchLabels, getSelectedLabels]);

    if (
        curriculumType === undefined ||
        !selectedList ||
        !selectedList.length ||
        hasSelectedWithoutLabels
    ) {
        return null;
    }

    const comparisonLabel = `Compare ${curriculumType.displayNamePlural ||
        curriculumType.displayName ||
        ''} (${selectedList.length}/5)`;

    return (
        <div className={styles.comparisonContainer}>
            <div className={styles.comparisonHeader}>Selected </div>
            <div className={styles.selectedItems}>
                {selectedList.map(selectedItem => {
                    const { uuid, label } = selectedItem;

                    return (
                        <button
                            key={uuid}
                            id={'comparison-selected-item-tag'}
                            className={styles.selectedItemTag}
                            onClick={() => removeSelectedItem(uuid)}
                        >
                            {label || uuid}
                            <i className="material-icons">clear</i>
                        </button>
                    );
                })}
            </div>
            <button
                id={'comparison-comparison-button'}
                onClick={() => setAppView(AppView.Comparison)}
                className={styles.comparisonButton}
            >
                {comparisonLabel}
            </button>
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Comparison);
